export default __webpack_public_path__ + "static/fancy_atoms-2d42805040c033c8e3518bd95cb08392.png";